<template>
  <div class="row no-gutters justify-content-between">
    <div class="col-sm-7 col-md-7" v-bind:class="{ 'col-md-12': isTablet }">
      <div class="content">
        <div class="content__head">
          <div class="tabs">
            <div class="tabs__head" id="c-menu">
              <nav class="tabs__nav">
                <ul>
                  <li>
                    <a
                      style="color: #1863b0 !important; font-weight: 700"
                      @click="goToSection('donation', $event)"
                      v-if="charity.length"
                      >Donation To Charity</a
                    >
                  </li>
                  <li>
                    <a
                      style="color: #1863b0 !important; font-weight: 700"
                      @click="goToSection('additional', $event)"
                      v-if="organization[0].sAddon"
                      >Additional Baskets</a
                    >
                  </li>
                  <li>
                    <a
                      style="color: #1863b0 !important; font-weight: 700"
                      @click="goToSection('upsell', $event)"
                      v-if="orderOptions.length && organization[0].sCards"
                      >Additional Items</a
                    >
                  </li>
                  <li>
                    <a
                      style="color: #1863b0 !important; font-weight: 700"
                      @click="goToSection('shipping', $event)"
                      v-if="organization[0].sSendout"
                      >Shipping Baskets</a
                    >
                  </li>
                </ul>
              </nav>
              <!-- /.tabs__nav -->
            </div>
            <!-- /.tabs__head -->

            <div class="tabs__body">
              <div class="tab">
                <div
                  class="sub-head"
                  v-if="charity.length && organization[0].id !== 682"
                >
                  Donation To Charity
                </div>
                <!-- temple beth zion id 682 custom donate text -->
                <div
                  class="sub-head"
                  v-if="charity.length && organization[0].id === 682"
                >
                  Donation to Temple Beth Zion
                </div>
                <div
                  class="box-form"
                  v-for="item in charity"
                  :key="item.charityId"
                  id="donation"
                >
                  <div class="box__head">
                    <p style="text-align: left">
                      <strong
                        v-html="item.charity"
                        v-if="item.charity"
                      ></strong>
                      <strong v-if="!item.charity && !item.customLabel"
                        >I would like to add an additional donation to the
                        {{ organization[0].name }}</strong
                      >
                      <strong
                        v-if="!item.charity && item.customLabel"
                        v-html="item.customLabel"
                      ></strong>
                    </p>
                  </div>
                  <!-- /.box__head -->

                  <div class="box__content" v-if="!item.hide">
                    <div class="form-frame form-frame--small">
                      <div class="form-row">
                        <div
                          class="
                            form-group
                            d-flex
                            justify-content-between
                            align-items-center
                            col-xl-6
                            flex-wrap
                          "
                        >
                          <label for="field-donate" class="form__label">
                            I would like to donate
                          </label>

                          <input
                            type="number"
                            class="field form-control-sm"
                            id="field-donate"
                            value="0"
                            v-model="item.value"
                          />
                          <md-button
                            class="btn-pink"
                            @click="addDonation(item.value, item)"
                            :disabled="item.disabled"
                            >Add
                          </md-button>
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->
                    </div>
                    <!-- /.form-checkout -->
                  </div>
                  <!-- /.box__content -->
                </div>
                <!-- /.box-form -->
                <div class="sub-head m-t-3" v-if="organization[0].sAddon">
                  Additional Gift Basket(s) for Personal Use
                </div>

                <div
                  class="box-form"
                  id="additional"
                  v-if="organization[0].sAddon"
                >
                  <div class="box__head">
                    <p>
                      <strong v-html="organization[0].sAddOnText"></strong>
                    </p>
                  </div>
                  <!-- /.box__head -->

                  <div class="box__content">
                    <div class="form-frame form-frame--small">
                      <div class="form-row">
                        <div
                          @click="
                            giftBasketDisabled
                              ? (giftBasketDisabledDialog = true)
                              : (giftBasketDisabledDialog = false)
                          "
                          class="
                            form-group
                            d-flex
                            justify-content-between
                            align-items-center
                            col-xl-6
                            flex-wrap
                          "
                          v-bind:class="{
                            wide:
                              shippingCustomOptions.length &&
                              customOptions.noShipCustom.indexOf(
                                organization[0].id
                              ) === -1,
                          }"
                        >
                          <label for="field-basket" class="form__label">
                            Additional Baskets
                          </label>

                          <input
                            type="number"
                            class="field form-control-sm"
                            id="field-basket"
                            value=""
                            v-model="basketAmount"
                          />
                          <!-- doesnt apply for organization 173 -->
                          <md-radio
                            v-model="selCustomOptionBasket"
                            :value="item.id"
                            v-for="item in shippingCustomOptions"
                            :key="item.id"
                            v-if="
                              customOptions.noShipCustom.indexOf(
                                organization[0].id
                              ) === -1
                            "
                          >
                            <span
                              v-if="
                                item.description !== 'Regular Baskets' &&
                                  item.description !== 'Premium Baskets'
                              "
                              >{{ item.description }}</span
                            >

                            <span v-if="item.description === 'Regular Baskets'"
                              >Regular</span
                            >
                            <span v-if="item.description === 'Premium Baskets'"
                              >Premium</span
                            >
                          </md-radio>

                          <md-button
                            class="btn-pink"
                            @click="
                              addBaskets(basketAmount, selCustomOptionBasket)
                            "
                            :disabled="giftBasketDisabled"
                            >Add</md-button
                          >
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->
                    </div>
                    <!-- /.form-checkout -->
                  </div>
                  <!-- /.box__content -->
                </div>
                <!-- /.box-form -->

                <div
                  class="sub-head m-t-3"
                  v-if="orderOptions.length && organization[0].sCards"
                >
                  Additional Items
                </div>

                <div
                  class="box-form"
                  v-if="orderOptions.length && organization[0].sCards"
                  id="upsell"
                >
                  <div class="box__head">
                    <p>
                      <strong v-if="!organization[0].sCardstext"
                        >This year we're also selling the following
                        items:</strong
                      >
                      <strong
                        v-html="organization[0].sCardstext"
                        v-if="organization[0].sCardstext"
                      ></strong>
                    </p>
                  </div>
                  <!-- /.box__head -->
                  <!-- Upsell section -->
                  <div class="box__content">
                    <div class="form-frame form-frame--small">
                      <div
                        class="form-row"
                        v-for="item in orderOptions"
                        :key="item.id"
                      >
                        <div
                          class="
                            form-group
                            d-flex
                            justify-content-between
                            align-items-center
                            col-xl-8
                            flex-wrap
                          "
                        >
                          <label for="field-widgets" class="form__label">{{
                            item.description
                          }}</label>

                          <div class="select select--grey">
                            <select id="field-widgets" v-model="item.value">
                              <option
                                v-for="q in item.quantities"
                                :value="q"
                                :key="q"
                              >
                                {{ q }}
                              </option>
                            </select>
                          </div>
                          <!-- /.select -->

                          <span class="form__note"
                            >{{
                              item.price | currency(settings[0].symbol)
                            }}
                            ea.</span
                          >
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->
                      <div class="text-right">
                        <md-button
                          class="btn-pink"
                          @click="addUpsell(orderOptions)"
                          >Add</md-button
                        >
                      </div>
                      <!-- /.form-row -->
                    </div>
                    <!-- /.form-checkout -->
                  </div>
                  <!-- /.box__content -->
                </div>
                <!-- /.box-form -->
                <!-- Additional Baskets -->
                <div class="sub-head m-t-3" v-if="organization[0].sSendout">
                  Shipping Baskets
                </div>
                <div
                  class="box-form"
                  id="shipping"
                  v-if="organization[0].sSendout"
                >
                  <div class="box__head">
                    <p>
                      <strong v-html="organization[0].sSendoutText"> </strong>
                    </p>
                  </div>
                  <!-- /.box__head -->

                  <div class="box__content">
                    <div class="form-frame form-frame--alt">
                      <div class="form-row">
                        <div class="form-group col-lg-12">
                          <label for="field-fname" class="form__label">
                            Recipient*
                          </label>

                          <input
                            type="text"
                            class="field"
                            id="field-fname"
                            placeholder
                            v-model="additionalBasket.recipient"
                            :class="{ error: basketError.recipient }"
                            @focus="basketError.recipient = false"
                          />
                        </div>
                        <!-- /.form-group -->

                        <!-- <div class="form-group col-lg-6">
                          <label for="field-lname" class="form__label">
                            Recipient Last Name
                          </label>

                          <input
                            type="text"
                            class="field"
                            id="field-lname"
                            placeholder
                            v-model="additionalBasket.lastName1"
                          />
                        </div> -->
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->

                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="field-address-3" class="form__label"
                            >Address1*</label
                          >

                          <input
                            type="text"
                            class="field"
                            id="field-address-3"
                            placeholder
                            v-model="additionalBasket.address1"
                            :class="{ error: basketError.address1 }"
                            @focus="basketError.address1 = false"
                          />
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->

                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="field-address-4" class="form__label"
                            >Address2</label
                          >

                          <input
                            type="text"
                            class="field"
                            id="field-address-4"
                            placeholder
                            v-model="additionalBasket.address2"
                          />
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->

                      <div class="form-row">
                        <div class="form-group col-lg-6">
                          <label for="field-city-2" class="form__label"
                            >City*</label
                          >

                          <input
                            type="text"
                            class="field"
                            id="field-city-2"
                            placeholder
                            v-model="additionalBasket.city"
                            :class="{ error: basketError.city }"
                            @focus="basketError.city = false"
                          />
                        </div>
                        <!-- /.form-group col-md-6 -->

                        <div class="form-group col-lg-2 col-md-6">
                          <label for="field-state-2" class="form__label"
                            >State</label
                          >

                          <!-- <div class="select "> -->
                          <input
                            type="text"
                            id="field-state-2"
                            class="field"
                            v-model="additionalBasket.state"
                          />
                          <!-- <select
                              id="field-state-2"
                              v-model="additionalBasket.state"
                            >
                              <option value>Select</option>
                              <option
                                :value="state.abbreviation"
                                v-for="state in states"
                                :key="state.abbreviation"
                              >
                                {{ state.abbreviation }}
                              </option>
                            </select> -->
                          <!-- </div> -->
                          <!-- /.select -->
                        </div>
                        <!-- /.form-group col-md-2 -->

                        <div class="form-group col-lg-4 col-md-6">
                          <label for="field-code-2" class="form__label">
                            Postal Code*
                          </label>

                          <input
                            type="text"
                            class="field"
                            id="field-code-2"
                            placeholder
                            v-model="additionalBasket.zip"
                            :class="{ error: basketError.zip }"
                            @focus="basketError.zip = false"
                          />
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->

                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label for="field-phone-2" class="form__label"
                            >Phone</label
                          >

                          <input
                            type="number"
                            class="field"
                            id="field-phone-2"
                            placeholder
                            v-model="additionalBasket.phoneNumber"
                          />
                        </div>
                        <!-- /.form-group -->

                        <div class="form-group col-md-6">
                          <label for="field-phone-3" class="form__label"
                            >Email</label
                          >

                          <input
                            type="email"
                            class="field"
                            id="field-phone-3"
                            placeholder
                            v-model="additionalBasket.email"
                          />
                        </div>
                        <!-- /.form-group -->
                      </div>
                      <!-- /.form-row -->

                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="field-message" class="form__label"
                            >Message</label
                          >

                          <textarea
                            name="field-message"
                            id="field-message"
                            cols="30"
                            class="field"
                            rows="2"
                            v-model="additionalBasket.message"
                          ></textarea>
                        </div>
                        <!-- /.form-group col-md-12 -->
                      </div>

                      <!-- {{ shippingCustomOptions }} -->

                      <div class="form-row row">
                        <!-- <div class="form-group col-md-12"> -->
                        <!-- <md-checkbox v-model="additionalBasket.glutenFree" >Gluten Free</md-checkbox> -->

                        <!-- :class="{ 'selected-custom-basket': selCustomOption ===
                        item.id, }" -->
                        <div
                          class="custom-basket col-4"
                          v-for="item in shippingCustomOptions"
                          :key="item.id"
                        >
                          <!-- <BasketImg
                            :item="item"
                            :index="index"
                            @onSelectedBasket="onSelectedCustomBasket"
                          ></BasketImg>
                          <span
                            v-if="
                              item.description !== 'Regular Baskets' &&
                                item.description !== 'Premium Baskets'
                            "
                            >{{ item.description }}
                          </span>
                          <span v-if="item.description === 'Regular Baskets'"
                            >Regular</span
                          >
                          <span v-if="item.description === 'Premium Baskets'"
                            >Premium</span
                          > -->
                          <md-radio
                            v-model="selCustomOption"
                            :value="item.id"
                            @change="changeBasketPrice(item.price)"
                          >
                            <span
                              v-if="
                                item.description !== 'Regular Baskets' &&
                                  item.description !== 'Premium Baskets'
                              "
                              >{{ item.description }}
                            </span>
                            <span v-if="item.description === 'Regular Baskets'"
                              >Regular</span
                            >
                            <span v-if="item.description === 'Premium Baskets'"
                              >Premium</span
                            ></md-radio
                          >
                        </div>
                        <!-- </div> -->
                      </div>
                      <!-- /.form-row -->

                      <div class="form__actions text-right">
                        <span class="required">*required fields</span>
                        <md-button
                          class="btn-pink"
                          @click="addAdditionalBasket(additionalBasket)"
                          >Add To Order</md-button
                        >
                      </div>
                      <!-- /.form__actions -->
                    </div>
                    <!-- /.form-checkout -->
                  </div>
                  <!-- /.box__content -->
                </div>
                <!-- /.box-form -->
              </div>
              <!-- /.tab -->
            </div>
            <!-- /.tabs__body -->
          </div>
          <!-- /.tabs -->
        </div>
        <!-- /.content__head -->
      </div>
      <!-- /.content -->
      <!-- Prompt If User wants to delete Baskte -->
      <div>
        <md-dialog-confirm
          :md-active.sync="showPromptRecip"
          class="prompt_dialog"
          md-title="Would you like to add reciprocity?"
          md-content="The reciprocity function enables you to automatically send to people that are sending to you. This is a great tool to ensure that you don’t inadvertently miss someone and that everyone that sends to you, gets from you in return. Please do NOT rely on this alone—if everyone just chooses reciprocity, and doesn’t select any recipients, no one will get anything!"
          md-confirm-text="Add To Order"
          md-cancel-text="No"
          @md-cancel="onCancel()"
          @md-confirm="selRecip()"
        />
      </div>

      <!-- <md-dialog :md-active.sync="showPromptRecip">
      <md-dialog-title>Would you like to add reciprocity?</md-dialog-title>
      <md-dialog-content>
        <div class="box__content">
The reciprocity function enables you to automatically send to people that are sending to you. This is a great tool to ensure that you don’t inadvertently miss someone and that everyone that sends to you, gets from you in return. Please do NOT rely on this alone—if everyone just chooses reciprocity, and doesn’t select any recipients, no one will get anything!
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="btn-grey" @click="onCancel()"
          >Cancel</md-button
        >
        <md-button class="btn-green" @click="selRecip()"
          >Add To Order</md-button
        >
      </md-dialog-actions>
    </md-dialog> -->
    </div>
    <!-- /.col-md-7 -->
    <div class="col-sm-5 col-md-5" v-bind:class="{ 'col-md-12': isTablet }">
      <div
        class="sidebar col-md-5"
        style="background-color: rgb(255 255 255 / 0%)"
        v-bind:class="{ 'col-md-12 sidebar-relative': isTablet }"
      >
        <CartPage />

        <div
          class="
            sidebar__actions
            d-flex
            flex-wrap
            justify-content-between
            align-items-center
          "
          v-bind:class="{ 'fixed-side-actions': !isMobile }"
        >
          <router-link to="/content/list" class="btn btn-grey btn-grey-long"
            >Go Back</router-link
          >
          <!-- <router-link
            to="/content/payment"
            class="btn btn--filter btn--dark-green text-center"
          >
            <span>Continue To Payment</span>
            <i class="ico-arrow-right"></i>
          </router-link> -->
          <a
            @click="navigateToPayment()"
            class="btn btn--filter btn--dark-green text-center"
          >
            <span>Continue To Payment</span>
            <i class="ico-arrow-right"></i>
          </a>
        </div>
        <!-- /.sidebar__actions -->
      </div>
    </div>
    <md-dialog-alert
      :md-active.sync="giftBasketDisabledDialog"
      class="prompt_dialog"
      md-title="Additional Baskets is already in your cart"
      md-content="you need to remove the existence additional baskets in your cart in order to add a different quantity"
      md-confirm-text="Ok"
      @md-confirm="giftBasketDisabledDialog = true"
    />
  </div>
  <!-- /.row -->
</template>
<script>
import CartPage from "../components/CartPage.vue";
import BasketImg from "../components/BasketImg.vue";
import $ from "jquery";
import json from "../assets/states.json";
import currencyFilter from "../shared/currency-filter";
import { showErrorAlert } from "../helpers";

export default {
  name: "PromoPage",
  components: { CartPage, BasketImg },
  filters: {
    currency: currencyFilter,
  },
  data: function() {
    return {
      giftBasketDisabledDialog: false,
      showPromptRecip: false,
      donation: 0,
      states: json,
      donationID: 0,
      basketID: 1,
      basketAmount: "",
      basketLabel: "Gift Baskets to be Shipped",
      basketDescription: "Shipping Gift Basket to",
      additionalBasket: {
        address: "",
        address2: "",
        city: "",
        country: "",
        email: "",
        glutenFree: false,
        message: "",
        phoneNumber: "",
        recipient: "",
        firstName1: "",
        lastName1: "",
        shippingItemGuid: "",
        shippingOptionId: "",
        state: "",
        zip: "",
        ApiID: 2,
        Price: 50,
        Qt: 1,
      },
      additionalBasketID: 1000,
      selCustomOption: -1,
      selCustomOptionBasket: -1,
      basketError: {
        recipient: false,
        address1: false,
        city: false,
        zip: false,
      },
    };
  },
  computed: {
    customOptions() {
      return this.$store.state.customOptions;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    isTablet() {
      return this.$store.getters.isTablet;
    },
    profile() {
      return this.$store.state.userProfile;
    },
    localDeliveryPricing() {
      return this.$store.state.localDeliveryPricing;
    },
    giftBasketDisabled() {
      let val = false;
      if (this.orderItems.filter((a) => a.itemId === (1 || 29 || 30)).length) {
        val = true;
      }
      return val;
    },
    charity() {
      let obj = this.$store.state.charity;
      let items = this.$store.state.charitycustom;

      for (let i = 0; i < obj.length; i++) {
        obj[i].value = "";
        if (
          this.orderItems.filter((a) => a.description === obj[i].disabledLabel)
            .length
        ) {
          obj[i].disabled = true;
        } else {
          obj[i].disabled = false;
        }
      }
      //  in case if they have custom charities and main one and they want to display fist one as info box
      if (obj.length && items.length) {
        for (let i = 0; i < items.length; i++) {
          let f_obj = obj.filter(
            (a) =>
              a.charityId === items[i].chaId &&
              a.customLabel === items[i].chaMessage
          );
          if (!f_obj.length) {
            obj.unshift({
              charity: "",
              customLabel: items[i].chaMessage,
              charityGuid: "",
              charityId: items[i].chaId,
              dateAdded: "",
              deleted: items[i].chaActive,
              disabledLabel: "Donation To Charity",
              displayOrder: 0,
              lastUpdated: "",
              shulId: items[i].chaShul,
              value: 0,
              hide: true,
            });
          }
        }
      } // if no custom charities just add main one to the charity collection and dont hide add button
      else if (!obj.length && items.length) {
        for (let i = 0; i < items.length; i++) {
          let f_obj = obj.filter(
            (a) =>
              a.charityId === items[i].chaId &&
              a.customLabel === items[i].chaMessage
          );
          if (!f_obj.length) {
            obj.unshift({
              charity: "",
              customLabel: items[i].chaMessage,
              charityGuid: "",
              charityId: items[i].chaId,
              dateAdded: "",
              deleted: items[i].chaActive,
              disabledLabel: "Donation To Charity",
              displayOrder: 0,
              lastUpdated: "",
              shulId: items[i].chaShul,
              value: 0,
              hide: false,
            });
          }
        }
      }
      return obj;
    },
    orderOptions() {
      return this.$store.state.orderOptions;
    },
    organization() {
      let sendout = this.$store.state.organizationInfo[0].sSendoutprice;
      this.additionalBasket.Price = sendout;
      this.additionalBasket.Value = sendout;
      return this.$store.state.organizationInfo;
    },
    shippingCustomOptions: function() {
      if (this.$store.state.shippingCustomOptions.length) {
        let c_option = this.$store.state.shippingCustomOptions[0].id;
        this.selCustomOption = c_option;
        this.selCustomOptionBasket = c_option;
      }
      return this.$store.state.shippingCustomOptions;
    },
    orderItems() {
      return this.$store.state.cart.orderItems;
    },
    settings() {
      return this.$store.state.settings;
    },
  },
  methods: {
    changeBasketPrice(price) {
      console.log("price change ", price);
      this.additionalBasket.Price = price;
    },

    onSelectedCustomBasket(item) {
      this.selCustomOption = item.id;
    },

    checkIfPplSelected(data) {
      let check = false;
      for (let i = 0; i < data.length; i++) {
        if (!data[i].paid && data[i].selected) {
          check = true;
          return check;
        }
      }
      return check;
    },
    selRecip: async function() {
      this.profile[0].reciprocity = true;
      await this.$store.dispatch("updateUserProfile", this.profile);
      this.$router.push("/content/payment").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    navigateToPayment() {
      let check = this.checkIfPplSelected(this.$store.state.list);
      if (
        !this.profile[0].reciprocity &&
        check &&
        this.organization[0].sReciprocity
      ) {
        this.showPromptRecip = true;
      } else {
        this.$router.push("/content/payment").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      }
    },
    onCancel: function() {
      this.showPromptRecip = false;
      //  this.$router.push("/content/payment")
      setTimeout(() => {
        this.$router.push("/content/payment").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      }, 100);
    },
    goToSection: function(id, event) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    },
    resetAdditionalBasket: function() {
      this.additionalBasket.address = "";
      this.additionalBasket.address1 = "";
      this.additionalBasket.city = "";
      this.additionalBasket.country = "";
      this.additionalBasket.email = "";
      this.additionalBasket.message = "";
      this.additionalBasket.recipient = "";
      this.additionalBasket.phoneNumber = "";
      this.additionalBasket.state = "";
      this.additionalBasket.glutenFree = false;
      this.additionalBasket.zip = "";
    },
    checkForLocalPrice: function(price, zip, shipoption) {
      let data = this.localDeliveryPricing;
      let p = price;
      for (let i = 0; i < data.length; i++) {
        if (
          data[i].enabled &&
          data[i].localDeliveryPrice &&
          data[i].zipCode.trim() === zip.trim()
        ) {
          console.log("this.organization", this.organization, shipoption);
          if (this.organization[0].id === 371 && shipoption === 5) {
            p = 15;
          } else {
            p = Number(data[i].localDeliveryPrice);
          }
        }
      }
      return p;
    },
    async addAdditionalBasket(item) {
      try {
        if (
          !this.additionalBasket.recipient ||
          !this.additionalBasket.address1 ||
          !this.additionalBasket.city ||
          !this.additionalBasket.zip
        ) {
          this.$store.commit("showToast", {
            message: "Recipient, Address, City, Postal Code cannot be empty!",
            position: "bottom",
            type: "error",
          });
          if (!this.additionalBasket.recipient)
            this.basketError.recipient = true;
          if (!this.additionalBasket.address1) this.basketError.address1 = true;
          if (!this.additionalBasket.city) this.basketError.city = true;
          if (!this.additionalBasket.zip) this.basketError.zip = true;
        } else {
          console.log("additional basket ", item);
          item.ID = this.additionalBasketID;
          item.Price = this.checkForLocalPrice(
            item.Price,
            item.zip,
            this.selCustomOption
          );
          console.log("item.Price", item.Price);

          this.$store.commit("addAdditionalBasket", item);
          this.additionalBasketID += 1;
          let obj = {
            itemId: item.ApiID,
            price: item.Price,
            quantity: item.Qt,
            description: this.basketDescription,
            shipTo: item.recipient,
            message: item.message,
          };
          console.log(
            "item",
            item,
            this.selCustomOption,
            obj,
            this.shippingCustomOptions
          );

          let shipping_obj = {
            message: item.message,
            recipient: item.recipient,
            address: item.address1,
            address2: item.address2,
            city: item.city,
            zip: item.zip,
            shippingOptionId: this.selCustomOption,
            email: item.email,
            phoneNumber: item.phoneNumber,
            glutenFree: item.glutenFree,
            state: item.state,
          };
          if (this.shippingCustomOptions.length) {
            this.changeBasketPrice(this.shippingCustomOptions[0].price);
            let c_option = this.$store.state.shippingCustomOptions[0].id;
            this.selCustomOption = c_option;
            this.selCustomOptionBasket = c_option;
          }

          await this.$store.dispatch("updateUpsell", {
            data: obj,
            param: "add",
          });
          await this.$store.dispatch("addShipping", {
            data: shipping_obj,
            param: "new",
          });

          setTimeout(() => this.resetAdditionalBasket(), 1000);
        }
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
    resetUpsell: function() {
      for (let i = 0; i < this.orderOptions.length; i++) {
        this.orderOptions[i].value = 0;
      }
    },
    async addUpsell(items) {
      try {
        let upsell = items.filter((a) => a.value > 0);
        this.$store.commit("addUpsell", upsell);
        console.log("itemzzz ", items, this.$store.state.cart.upsell);
        for (let i = 0; i < this.$store.state.cart.upsell.length; i++) {
          if (this.$store.state.cart.upsell[i].Qt > 0) {
            let obj = {
              itemId: 5,
              price: this.$store.state.cart.upsell[i].Price,
              quantity: this.$store.state.cart.upsell[i].Qt,
              description: this.$store.state.cart.upsell[i].Label,
              shipTo: "",
              message: "",
            };
            console.log("obj ", obj);
            await this.$store.dispatch("updateUpsell", {
              data: obj,
              param: "add",
            });
            // this.$store.dispatch("getOrderItems");
          }
        }
        this.resetUpsell();
        this.$store.commit("showToast", {
          message: "Added To Cart",
          position: "bottom",
          type: "success",
        });
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },

    async addBaskets(baskets, type) {
      try {
        if (baskets > 0) {
          let price = this.organization[0].sAddonprice;
          let id = 1;
          if (
            this.shippingCustomOptions.length &&
            this.customOptions.noShipCustom.indexOf(this.organization[0].id) ===
              -1
          ) {
            let obj = this.shippingCustomOptions.filter(
              (a) => a.id === Number(type)
            );
            if (obj.length) {
              price = obj[0].price;
            }
            id = type;
          }
          this.$store.commit("addBaskets", {
            ID: id,
            Label: "Addition Gift Basket(s) for Personal Use",
            Price: price,
            Value: price,
            Qt: Number(baskets),
          });
          console.log("basket ", price);
          this.basketAmount = "";
          if (this.$store.state.cart.additional.length) {
            let donation = {
              itemId: id,
              price: price,
              quantity: this.$store.state.cart.additional[0].Qt,
              description: "Addition Gift Basket(s) for Personal Use",
              shipTo: "",
              message: "",
            };
            await this.$store.dispatch("updateUpsell", {
              data: donation,
              param: "add",
            });
          }
          this.$store.commit("showToast", {
            message: "Added To Cart",
            position: "bottom",
            type: "success",
          });
        }
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },

    async addDonation(amount, item) {
      try {
        if (amount > 0) {
          //   organization[0].id !== 682
          let new_item = {
            ID: item.charityId,
            Label:
              item.charity + ": " + this.settings[0].symbol + Number(amount),
            value: Number(amount),
            Price: Number(amount),
            charityId: item.charityId,
            description: item.charity,
            itemId: this.donationID,
          };
          if (this.organization[0].id === 682) {
            new_item.Label =
              "Donation to Temple Beth Zion" + ": $" + Number(amount);
            new_item.description = "Donation to Temple Beth Zion";
          }
          console.log("item ", item, new_item);

          this.$store.commit("addDonation", new_item);

          this.$store.commit("showToast", {
            message: "Added To Cart",
            position: "bottom",
            type: "success",
          });

          item.value = 0;
          let obj = this.$store.state.cart.donations.filter(
            (a) => a.charityId === item.charityId
          );
          if (obj.length) {
            let donation = {
              itemId: obj[0].itemId,
              price: obj[0].Price,
              quantity: 1,
              description: "Donation To Charity - " + obj[0].description,
              shipTo: "",
              message: "",
            };
            if (this.organization[0].id === 682) {
              donation.description = "Donation to Temple Beth Zion";
            }
            await this.$store.dispatch("updateUpsell", {
              data: donation,
              param: "add",
            });
          }
        }
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
  },
  async created() {
    window.scrollTo(0, 0);
    await this.$store.dispatch("getPaymentMethods");
    await this.$store.dispatch("getDiscounts");
    // this.$store.dispatch("getTotal");
    // this.$store.dispatch("getOrderItems");
    if (!this.$store.state.userProfile.length) {
      await this.$store.dispatch("getUserProfile");
    }
  },
  async mounted() {
    await this.$store.dispatch("getTotal");
    await this.$store.dispatch("getOrderItems");
  },
};
</script>
<style scoped>
.box-form:after {
  width: 100% !important;
  background-color: #ff607f;
}
.wide {
  flex: 0 0 95%;
  max-width: 95%;
}
.sidebar {
  position: fixed;
  min-height: auto;
  height: auto;
  min-width: 600px;
}
.btn-pink[disabled],
.disabled {
  background: #c4c4c4 !important;
  box-shadow: 2px 2px 5px 0px #c4c4c4;
  cursor: not-allowed;
}
.sub-head {
  text-align: left;
  font-size: 20px;
  padding-bottom: 1em;
  color: #ff607f;
}
.m-t-3 {
  margin-top: 3em;
}
.tabs .tabs__nav ul {
  margin-bottom: 0;
  text-align: left;
}
.sidebar-relative {
  position: relative;
}
@media (max-width: 1200px) {
  .content {
    padding: 10px;
  }
}
@media (max-width: 767px) {
  .tabs .tabs__nav ul li a {
    padding: 5px;
    font-size: 12px;
  }
  .sidebar {
    position: relative;
    min-width: auto;
  }
  .member-wrap {
    margin: 0;
  }
  .sidebar .sidebar__actions {
    padding: 0;
  }
  .sub-head {
    font-size: 18px;
  }
  h4 {
    font-weight: 600;
    font-size: 14px;
  }
}
.md-dialog /deep/ .md-dialog-title {
  margin-bottom: 20px;
  padding: 12px 24px 12px;
  background: #ff607f;
  color: white;
}
/* .md-dialog.prompt_dialog /deep/  button.md-button.md-primary.md-theme-default :first-child{
  background: #4bbe56;
  color: white;
  font-weight: 500;
} */
.select:after {
  z-index: 3;
  background-image: url(../assets/images/down.png);
  background-repeat: no-repeat;
  background-size: cover;
  width: 30px;
}
.select select {
  z-index: 4;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}
.select:before {
  display: none;
}
.required {
  display: block;
  width: 100%;
  text-align: left;
  color: red;
}
.error {
  border-color: red;
}

.custom-basket {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}
.selected-custom-basket {
  border-width: 2px;
  border-style: solid;
  border-color: #ff607f;
  border-radius: 5px;
}
</style>
